import { render, staticRenderFns } from "./muokkaa-seurantajaksoa-kouluttaja-vastuuhenkilo.vue?vue&type=template&id=09f40259&scoped=true&"
import script from "./muokkaa-seurantajaksoa-kouluttaja-vastuuhenkilo.vue?vue&type=script&lang=ts&"
export * from "./muokkaa-seurantajaksoa-kouluttaja-vastuuhenkilo.vue?vue&type=script&lang=ts&"
import style0 from "./muokkaa-seurantajaksoa-kouluttaja-vastuuhenkilo.vue?vue&type=style&index=0&id=09f40259&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09f40259",
  null
  
)

export default component.exports